// extracted by mini-css-extract-plugin
export var title = "title-module--title--3hZWV";
export var spoilerTitle = "title-module--spoilerTitle--Qdr7W";
export var mobilePageTitle = "title-module--mobilePageTitle--2VpLV";
export var calendarMonth = "title-module--calendarMonth--2w3vQ";